import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { FiatSendFormData } from 'pages/Wallets/components/FiatSend/form/fiatSendFormSchema'
import { PayForm } from 'pages/Wallets/components/Pay/Pay'
import { Currencies } from 'types/types'

interface PayoutPaymentReferenceTransferDestinationLimits {
  LOCAL: { min: number; max: number }
  INTERNATIONAL: { min: number; max: number }
}

interface PayoutPaymentReferenceLimits {
  [Currencies.AED]: PayoutPaymentReferenceTransferDestinationLimits
  [Currencies.EUR]: PayoutPaymentReferenceTransferDestinationLimits
  [Currencies.GBP]: PayoutPaymentReferenceTransferDestinationLimits
  [Currencies.USD]: PayoutPaymentReferenceTransferDestinationLimits
  default: PayoutPaymentReferenceTransferDestinationLimits
}

const PAYMENT_REFERENCE_VALIDATION_PATTERN = /^[a-zA-Z0-9\s]*$/

export const PAYOUT_PAYMENT_REFERENCE_LIMITS: PayoutPaymentReferenceLimits = {
  [Currencies.AED]: {
    LOCAL: { min: 5, max: 70 },
    INTERNATIONAL: { min: 5, max: 70 },
  },
  [Currencies.EUR]: {
    LOCAL: { min: 5, max: 70 },
    INTERNATIONAL: { min: 5, max: 70 },
  },
  [Currencies.GBP]: {
    LOCAL: { min: 5, max: 18 },
    INTERNATIONAL: { min: 5, max: 18 },
  },
  [Currencies.USD]: {
    LOCAL: { min: 5, max: 10 },
    INTERNATIONAL: { min: 5, max: 115 },
  },
  default: {
    LOCAL: { min: 5, max: 20 },
    INTERNATIONAL: { min: 5, max: 20 },
  },
}

export const createPaymentReferenceSchema = (
  label: string,
  t: TFunction<'translation', undefined>,
  isRequired = false
) => {
  const schema = yup
    .string()
    .trim()
    .label(label)
    .test({
      test(value, ctx) {
        const { currencyCode, transferDestination } = (ctx?.parent || {}) as
          | PayForm
          | FiatSendFormData
        const limits =
          PAYOUT_PAYMENT_REFERENCE_LIMITS?.[currencyCode]?.[transferDestination] ||
          PAYOUT_PAYMENT_REFERENCE_LIMITS?.default?.[transferDestination]

        if (value) {
          if (value.length < limits?.min || value.length > limits?.max) {
            return ctx.createError({
              message: t('referenceFieldInvalidLength', { min: limits?.min, max: limits?.max }),
            })
          }

          if (!PAYMENT_REFERENCE_VALIDATION_PATTERN.test(value)) {
            return ctx.createError({
              message: t('referenceFieldInvalidCharacters', {
                field: label,
              }),
            })
          }

          return true
        } else if (isRequired) {
          return ctx.createError({
            message: t('fieldRequired', { field: t('beneficiaryPaymentReference') }),
          })
        } else {
          return ctx.schema.notRequired()
        }
      },
    })

  return schema
}
